var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.457,
    height: 14.521,
    viewBox: "0 0 17.457 14.521",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "twitter-ico",
    d: "M17.18,36.18a6.912,6.912,0,0,1-1.2.406,3.753,3.753,0,0,0,.991-1.578h0a.2.2,0,0,0-.288-.229h0a6.946,6.946,0,0,1-1.84.76.469.469,0,0,1-.115.014.488.488,0,0,1-.322-.123,3.763,3.763,0,0,0-2.49-.94,4.024,4.024,0,0,0-1.192.184A3.646,3.646,0,0,0,8.262,37.3a4.015,4.015,0,0,0-.089,1.386.135.135,0,0,1-.034.106.14.14,0,0,1-.1.047H8.021a9.869,9.869,0,0,1-6.783-3.624h0a.2.2,0,0,0-.323.025h0a3.768,3.768,0,0,0,.612,4.575,3.373,3.373,0,0,1-.858-.332h0a.2.2,0,0,0-.292.17h0a3.768,3.768,0,0,0,2.2,3.472H2.5a3.387,3.387,0,0,1-.634-.06h0a.2.2,0,0,0-.224.253h0a3.772,3.772,0,0,0,2.979,2.566,6.945,6.945,0,0,1-3.89,1.181H.291a.288.288,0,0,0-.282.217.3.3,0,0,0,.143.329,10.33,10.33,0,0,0,5.191,1.4,10.471,10.471,0,0,0,4.436-.941,9.8,9.8,0,0,0,3.246-2.432,10.663,10.663,0,0,0,1.987-3.328,10.514,10.514,0,0,0,.676-3.643V38.61a.64.64,0,0,1,.24-.5,7.439,7.439,0,0,0,1.5-1.643h0a.2.2,0,0,0-.243-.289Z",
    transform: "translate(0 -34.491)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIco);
export default __webpack_public_path__ + "static/media/twitter-ico.efa798dcf72fa4de89b57612e2af9328.svg";
export { ForwardRef as ReactComponent };